import styled from 'styled-components';

export const FeedbackShell = styled.form`
  box-sizing: border-box;
  display: grid;
  gap: 20px;
  width: min(100%, 930px);
  padding: 26px 38px 28px;
  border-radius: ${(p) => p.theme.radii.lg};
  background: ${(p) => p.theme.colors.light};

  @media (max-width: 768px) {
    padding: 24px 18px;
  }

  @media (max-width: 639px) {
    gap: 16px;
    padding: 20px 12px 24px;
    border-radius: 12px;
  }
`;

export const SubmittedShell = styled.div`
  box-sizing: border-box;
  display: grid;
  justify-items: center;
  gap: 18px;
  width: min(100%, 930px);
  min-height: 520px;
  padding: 72px 24px 54px;
  border-radius: ${(p) => p.theme.radii.lg};
  background: ${(p) => p.theme.colors.light};
  color: ${(p) => p.theme.colors.gray500};
  text-align: center;

  @media (max-width: 639px) {
    min-height: 420px;
    padding: 52px 12px 40px;
    border-radius: 12px;
  }
`;

export const CheckCircle = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: ${(p) => p.theme.colors.secondary400};
  color: ${(p) => p.theme.colors.light};
  font-size: 46px;
  line-height: 1;
`;

export const SubmittedTitle = styled.h2`
  margin: 0;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.md};
  font-weight: 700;
`;

export const SubmittedText = styled.p`
  max-width: 430px;
  margin: 0;
  color: ${(p) => p.theme.colors.gray400};
  font-size: ${(p) => p.theme.fontSizes.md};
  line-height: 1.25;
`;

export const StatusText = styled.p`
  margin: 0;
  color: ${(p) => p.theme.colors.gray400};
  font-size: ${(p) => p.theme.fontSizes.base};

  strong {
    color: ${(p) => p.theme.colors.secondary500};
    font-weight: 500;
  }
`;

export const SectionTitle = styled.h3`
  margin: 0;
  color: ${(p) => p.theme.colors.primary500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 700;
`;

export const BodyText = styled.p`
  margin: 0;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  line-height: 1.4;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: 190px minmax(0, 1fr);
  gap: 7px 24px;

  @media (max-width: 768px) {
    grid-template-columns: 121px minmax(0, 1fr);
    gap: 8px 12px;
  }
`;

export const InfoLabel = styled.p`
  margin: 0;
  color: ${(p) => p.theme.colors.gray300};
  font-size: ${(p) => p.theme.fontSizes.sm};
`;

export const InfoValue = styled.p`
  margin: 0;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 600;

  @media (max-width: 639px) {
    font-weight: 400;
    overflow-wrap: anywhere;
  }
`;

export const Divider = styled.hr`
  width: 100%;
  margin: 0;
  border: 0;
  border-top: 1px solid ${(p) => p.theme.colors.gray100};
`;

export const FieldGroup = styled.div`
  display: grid;
  gap: 10px;
`;

export const ChoiceWithInput = styled.div`
  display: grid;
  gap: 6px;
`;

export const ChoiceInputSlot = styled.div`
  width: min(100%, 640px);
  margin-left: 34px;

  @media (max-width: 639px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const FieldLabel = styled.label`
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 700;
`;

export const ValidationText = styled.p`
  margin: 0;
  color: ${(p) => p.theme.colors.danger};
  font-size: ${(p) => p.theme.fontSizes.sm};
`;

export const UnderlineInput = styled.input`
  width: 100%;
  height: 34px;
  border: 0;
  border-bottom: 1px solid ${(p) => p.theme.colors.gray100};
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};

  &:focus {
    outline: 0;
    border-bottom-color: ${(p) => p.theme.colors.primary300};
  }
`;

export const UnderlineTextarea = styled.textarea`
  width: 100%;
  min-height: 42px;
  border: 0;
  border-bottom: 1px solid ${(p) => p.theme.colors.gray100};
  color: ${(p) => p.theme.colors.gray500};
  font-family: inherit;
  font-size: ${(p) => p.theme.fontSizes.sm};
  resize: vertical;

  &:focus {
    outline: 0;
    border-bottom-color: ${(p) => p.theme.colors.primary300};
  }
`;

export const ChoiceStack = styled.div`
  display: grid;
  gap: 9px;
`;

export const ChoiceLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
`;

export const PartTitle = styled.h4`
  margin: 0;
  color: ${(p) => p.theme.colors.primary500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 700;
`;

export const RatingBlock = styled.div`
  display: grid;
  gap: 8px;
`;

export const RatingLabel = styled.p`
  margin: 0;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 700;
`;

export const SignatureRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;

  @media (max-width: 639px) {
    align-items: stretch;
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;

export const SignaturePreview = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: -4px 0 4px 4px;
`;

export const SignaturePreviewImage = styled.img`
  display: block;
  width: min(220px, 100%);
  max-height: 88px;
  object-fit: contain;
  border: 1px solid ${(p) => p.theme.colors.gray100};
  background: ${(p) => p.theme.colors.light};
`;

export const SignaturePreviewAction = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  color: ${(p) => p.theme.colors.primary300};
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
`;

export const SignedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 68px;
  height: 34px;
  padding: 0 12px;
  border-radius: ${(p) => p.theme.radii.base};
  background: ${(p) => p.theme.colors.secondary500};
  color: ${(p) => p.theme.colors.light};
  font-size: ${(p) => p.theme.fontSizes.sm};
  font-weight: 700;
`;

export const ActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 639px) {
    display: grid;
    grid-template-columns: 1fr;

    button {
      width: 100%;
    }
  }
`;
